import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import "./approvalworkflowlisting.scss";
import threedotvertical from "../../../assets/images/three-dots-vertical.svg";
import editicon from "../../../assets/images/edit-icon.svg";
import viewicon from "../../../assets/images/view-icon.svg";
import deleteicon from "../../../assets/images/delete-icon.svg";
import duplicatePlusIcon from "../../../assets/images/duplicate-plus-icon.svg";
import { ReactSVG } from "react-svg";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../redux/hooks";
import { selectCurrentUserId } from "../../../redux/auth/authSlice";
import useApprovalWorkflow from "../../../Hooks/useApprovalWorkflow";
import Loading from "../../../components/LoadingPage/Loading";
import { toggleClass } from "../../../utils/commonUtils";
import { DeleteConfModel } from "../../../components/DeleteConfModel/deleteConfModel";
import { CommonDuplicateModel } from "../../../components/commonDuplicateModel/duplicateModel";
import { ApprovalWorkflow } from "../../../redux/approvalWorkflow/approvalWorkflowSlice";
import ItemListingTitle from "../../../components/itemListingTitle/itemListingTitle";
import moment from "moment";

const ApprovalWorkflowListing = () => {
  const navigate = useNavigate();
  const currentUserId = useAppSelector(selectCurrentUserId);
  const {
    getApprovalWorkflowsAPI,
    getApprovalWorkflowsLoading,
    deleteApprovalWorkflowAPI,
    deleteApprovalWorkflowLoading,
    duplicateApprovalWorkflowAPI,
    duplicateApprovalWorkflowLoading,
  } = useApprovalWorkflow();
  const [showModal, setShowModal] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [workflowList, setWorkflowList] = useState<ApprovalWorkflow[]>([]);
  const [currentWorkflow, setCurrentWorkflow] = useState<ApprovalWorkflow>();
  const defaultFilter = { searchText: "", active: true };
  const [searchFieldVal, setSearchFieldVal] = useState(defaultFilter);

  const deleteWorkflow = async () => {
    await deleteApprovalWorkflowAPI({
      id: currentWorkflow?.id,
      updatedBy: currentUserId ?? "",
    });
    toggleModal();
    getWorkflows();
  };

  const duplicateWorkflow = async () => {
    await duplicateApprovalWorkflowAPI({
      id: currentWorkflow?.id,
      updatedBy: currentUserId ?? "",
    });
    toggleDuplicateModal();
    getWorkflows();
  };

  const toggleModal = () => {
    toggleClass();
    setShowModal(!showModal);
  };

  const toggleDuplicateModal = () => {
    toggleClass();
    setShowDuplicateModal(!showDuplicateModal);
  };

  const getWorkflows = () => {
    getApprovalWorkflowsAPI(searchFieldVal)
      .then((res: any) => setWorkflowList(res))
      .catch();
  };

  useEffect(() => {
    getWorkflows();
  }, [searchFieldVal]);

  return (
    <div className="approval-workflow-listing-wrapper">
      {(getApprovalWorkflowsLoading || deleteApprovalWorkflowLoading || duplicateApprovalWorkflowLoading) ? <Loading /> : null}
      <ItemListingTitle
        title="Approval Workflows"
        buttonTitle="Add New"
        href="/add-approval-workflow"
        disRecords={workflowList.length || 0}
        totalRecords={workflowList.length || 0}
        searchVal={searchFieldVal}
        setSearchVal={setSearchFieldVal}
        defaultFilter={defaultFilter}
        isAddPermitted={true}
      />
      <div className="listing-table-wrapper">
        <Table responsive="md" hover={true}>
          <thead>
            <tr>
              <th>Module Name</th>
              <th>Workflow Name</th>
              <th>Approval Mode</th>
              <th>Active</th>
              {/* <th>Created On</th> */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {workflowList?.map((x: ApprovalWorkflow) => (
              <tr
                key={x.id}
                onDoubleClick={() => navigate(`/view-approval-workflow/${x.id}`)}
              >
                <td title={x.moduleName}>{x.moduleName}</td>
                <td title={x.workflowName}>{x.workflowName}</td>
                <td title={x.approvalMode?.mode}>{x.approvalMode?.mode}</td>
                <td>{x.isActive ? "Yes" : "No"}</td>
                {/* <td>
                  <span title={x.createdOnUtc}>
                    {moment(x.createdOnUtc).format("MM/DD/YYYY")}
                  </span>
                </td> */}
                <td>
                  <Dropdown>
                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                      <ReactSVG
                        className="svg-box"
                        wrapper="span"
                        src={threedotvertical}
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href={`/view-approval-workflow/${x.id}`}>
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={viewicon}
                        />
                        View
                      </Dropdown.Item>
                      <Dropdown.Item href={`/edit-approval-workflow/${x.id}`}>
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={editicon}
                        />
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setCurrentWorkflow(x);
                          toggleModal();
                        }}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={deleteicon}
                        />
                        Delete
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setCurrentWorkflow(x);
                          toggleDuplicateModal();
                        }}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={duplicatePlusIcon}
                        />
                        Duplicate
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <DeleteConfModel
        showModal={showModal}
        toggleModal={toggleModal}
        deleteAction={deleteWorkflow}
        recordName={currentWorkflow?.workflowName || ""}
        modelName={`approval workflow`}
        isDeletePermitted={true}
      />
      <CommonDuplicateModel
        showDuplicateModal={showDuplicateModal}
        toggleDuplicateModal={toggleDuplicateModal}
        modelName={`approval workflow`}
        recordName={currentWorkflow?.workflowName || ""}
        duplicate={duplicateWorkflow}
        isDuplicatePermitted={true}
      />
    </div>
  );
};

export default ApprovalWorkflowListing;
